export class GlobalVars {
    //comment this in production
    // public static EnitiyIdVisa: string = "8ac7a4c975b6d9ec0175b7f62e990470";
    // public static EnitiyIdMada: string = "8ac7a4c975b6d9ec0175b7f6f0b90475";
    // public static EnitiyIdAPPLE: string = "8ac9a4c97f92421a017fab8327295e83";
    // public static ApiGatewayUrl: string = "https://test.oppwa.com/v1/checkouts";
    // public static PaymentDetailsUrl: string = "https://test.oppwa.com/v1/checkouts/{id}/payment?entityId={entityId}";    
    // public static ApiGatewayToken: string = "Bearer OGFjN2E0Yzk3NWI2ZDllYzAxNzViN2Y1ZTUzNzA0NmN8bkVZSjMzWWg1Wg==";
    // public static Currency: string = "SAR";
    // public static PaymentType: string = "DB";
    // public static TestModeVisa: string = "EXTERNAL";
    // public static TestModeMada: string = "INTERNAL";
    // public static ApiFormUrl: string = "https://test.oppwa.com/v1/paymentWidgets.js?checkoutId="


    // //uncomment this in production
    public static EnitiyIdVisa: string = "8acda4cd7f924b7b017f9772345c48e4";
    public static EnitiyIdMada: string = "8acda4cd7f924b7b017f9772345c48e4";//"8acda4cd7f924b7b017f9773172a490f";
    public static EnitiyIdAPPLE: string = "8ac9a4c97f92421a017fab8327295e83";
    public static ApiGatewayUrl: string = "https://oppwa.com/v1/checkouts";
    public static PaymentDetailsUrl: string = "https://oppwa.com/v1/checkouts/{id}/payment?entityId={entityId}";    
    public static ApiGatewayToken: string = "Bearer OGFjZGE0Y2Q3ZjkyNGI3YjAxN2Y5NzcxNzdiMjQ4Y2N8cFhiSEI0VGdDMg==";
    public static ApiFormUrl: string = "https://oppwa.com/v1/paymentWidgets.js?checkoutId="
    public static Currency: string = "SAR";
    public static PaymentType: string = "DB";
   


}